// extracted by mini-css-extract-plugin
export default {"tableAvatar":"adminUserList_tableAvatar__vXfFa","tableAvatar__img":"adminUserList_tableAvatar__img__fhtmY","rank":"adminUserList_rank__zrNnz","status":"adminUserList_status__ekan9"};